// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — schedule.styled.classic.js, новая — schedule.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './schedule.styled.classic';
import * as cp from './schedule.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const Scroll = isCp ? cp.Scroll : classic.Scroll;
export const Table = isCp ? cp.Table : classic.Table;
